import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const isPPE = process.env.REACT_APP_ANALYTICS_ENV === "ppe";
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: "en-us",
    debug: true,
    backend: {
      loadPath: isPPE
        ? "/{{lng}}/isv/marketplace-app-advisor/i18n/{{lng}}.json"
        : "/{{lng}}/software-development-companies/app-advisor/guidance/i18n/{{lng}}.json",
    },
    detection: {
      order: ["path", "cookie", "localstorage", "domain"],
    },
  });
